import { mapLocaleCodeToCountry } from '@features/WordPress/utilities/helpers/locale';
import styles from './LicensePlateAddon.module.css';
import { useRouter } from 'next/router';
import { LocalePrefix } from '@shared/types/prefix';
import EuStarsLarge from '@icons/eu-stars-large.svg';
import EuStarsSmall from '@icons/eu-stars-small.svg';
import NoFlagIcon from '@icons/no-flag.svg';
import { isMobileBelowWidth } from '@utilities/consts';
import useWindowSize from '@hooks/use-window-size';
import classNames from 'classnames';
const { CountryLabel, HasError } = styles;

interface LicensePlateAddonProps {
  error?: boolean;
}

const LicensePlateAddon = ({ error }: LicensePlateAddonProps) => {
  const windowSize = useWindowSize();
  const { locale } = useRouter();

  const classes = classNames(CountryLabel, {
    [HasError]: error,
  });

  const countryCodePrefix = mapLocaleCodeToCountry(locale);
  const isMobile = windowSize.width && windowSize.width < isMobileBelowWidth;

  const countryCodePrefixLabel = (prefix: string) =>
    prefix === LocalePrefix.DK ? prefix : prefix.substr(0, 1);

  // Hide Eu stars for NO
  const handleEuIcon = (country: string) => {
    switch (country) {
      case LocalePrefix.NO:
        return <NoFlagIcon />;
      default:
        return isMobile ? <EuStarsSmall /> : <EuStarsLarge />;
    }
  };

  return (
    <div className={classes}>
      {handleEuIcon(countryCodePrefix)}

      <div>{countryCodePrefixLabel(countryCodePrefix)}</div>
    </div>
  );
};

export default LicensePlateAddon;
